export default {
  shareMeta: {
    title: "Foto de <xx1> en PixelHaha",
    description:
      "Descargue esta foto gratuita creada por <xx1> usando el generador de imágenes de IA en PixelHaha.",
  },
  home: {
    picTitle: "Imágenes de stock gratuitas",
    recentSearch: "Búsquedas recientes",
    clear: "claro",
    trendsSearch: "Búsquedas de tendencia",
    details: "Detalles",
    enhance: "Mejorar",
    reimagine: "Reimaginar",
  },
  search: {
    guess: "También te podría gustar",
    trending: "Tendencias",
    newest: "El más nuevo",
    empty: "Aún no hay resultados de búsqueda.",
    goCreate: "Ve a crear la imagen",
    searchPlaceholder: "La inspiración comienza aquí...",
  },
  detail: {
    report: "Informe",
    downloadFree: "Descarga gratis",
    prompt: "Inmediato",
    more: "También te podría gustar",
    toCreate: "Crear",
    enhance: "Mejora de fotografías",
    invalid:
      "Enlace no disponible. El creador canceló la publicación o la imagen no cumple con los requisitos.",
    generation: "PixelHaha le ofrece generación de imágenes de alta calidad.",
    exploreMore: "Explorar más",
    jpg: "JPG",
    png: "PNG",
    download : "Descarga fallida. Verifique su conexión de red y vuelva a intentarlo.",
  },
  trends: {
    bgTip: "Búsquedas de tendencia",
    wrong: "Algo salió mal",
    retry: "Rever",
    top: "Arriba",
    a: "A",
    b: "B",
    c: "C",
    d: "D",
    e: "E",
    f: "F",
    g: "G",
    h: "H",
    i: "I",
    j: "J",
    k: "K",
    l: "L",
    m: "M",
    n: "N",
    o: "O",
    p: "P",
    q: "Q",
    r: "R",
    s: "S",
    t: "T",
    u: "U",
    v: "V",
    w: "W",
    x: "X",
    y: "Y",
    z: "Z",
  },
  img: {
    notReviewed: "Esta imagen no ha sido revisada",
    posting: "Destino...",
    deleteQ: "¿Confirmar eliminación?",
    cancel: "Cancelar",
    delete: "Borrar",
  },
  ugcPage: {
    editName: "Editar nombre",
    finish: "Finalizar",
    goHistory: "Ir al historial publicar",
    tabWork: "Trabajar",
    tabFavorites: "Favoritos",
    empty: "Sin datos",
    avatarTypeError: "Solo se admiten .png, .jpg y .webp",
  },
  siteMap: {
    page: "Página",
    sort: "Clasificar",
    keywords: "Palabras clave",
  },
  report: {
    title: "Reportar contenido",
    text: "¿Por qué estás informando esto?",
    reason1: "Violación de las condiciones de uso",
    reason2: "Baja calidad",
    reason3: "Correo basura",
    reason4: "Contenido sensible",
    reason5: "Otro",
    textplaceholder:
      "Describa los problemas que ha encontrado, siendo lo más específico posible.",
    submit: "Confirmar informe",
    toastSuccess:
      "El informe se ha enviado correctamente. Lo revisaremos pronto.",
    toastFailed: "No se pudo enviar el informe, por favor intente nuevamente.",
  },
};
